import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Mail, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api } from "@/lib/api";
import { toast } from "sonner";
import AlphaCoreLogo from "@/components/AlphaCoreLogo";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setDone(true);
      toast.success("Check your inbox");
    } catch {
      toast.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col bg-[#050505] text-white">
      <div className="p-6 border-b border-white/5"><Link to="/"><AlphaCoreLogo size={40} /></Link></div>
      <div className="flex-1 flex items-center justify-center p-6">
        <div className="w-full max-w-md">
          <Link to="/login" className="inline-flex items-center text-sm text-white/50 hover:text-white kr-link" data-testid="back-to-login">
            <ArrowLeft className="h-4 w-4 mr-1" /> Back to sign in
          </Link>
          <div className="kr-overline text-white/40 mt-6">[ RESET PASSWORD ]</div>
          <h1 className="font-display text-3xl mt-2 tracking-tight">Forgot it? Happens.</h1>
          {done ? (
            <p className="text-white/60 mt-6 text-sm">If <span className="text-white">{email}</span> exists in our system, a reset link is on its way.</p>
          ) : (
            <form onSubmit={submit} className="mt-6 space-y-4">
              <div>
                <Label className="kr-overline">Email</Label>
                <div className="relative mt-2">
                  <Mail className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-white/30" />
                  <Input data-testid="forgot-email-input" required type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="pl-9 bg-[#0A0A0E] border-white/10 h-11" />
                </div>
              </div>
              <Button type="submit" disabled={loading} className="w-full bg-[#00E5FF] text-black hover:bg-[#00E5FF]/90 rounded-md h-11 font-semibold" data-testid="forgot-submit-btn">
                {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Send reset link"}
              </Button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
